import { memo } from 'react';
import { useTranslate } from '@tolgee/react';

type StatusProps = {
  status:
    | 'InStock'
    | 'OutOfStock'
    | 'MarkedOutOfStock'
    | 'PartialOutOfStock'
    | 'ErpInStock'
    | 'ErpOutOfStock';
};
const StatusTag = memo((props: StatusProps) => {
  const { status } = props;
  const { t } = useTranslate();

  if (status === 'InStock') {
    return (
      <div className="inline-block leading-[18px] px-[8px] py-[3px] text-[12px] text-[#f2a100] bg-[#fffaf0] rounded-[2px]">
        {t('outofstock_status_2')}
      </div>
    );
  }
  if (status === 'MarkedOutOfStock') {
    return (
      <div className="inline-block leading-[18px] px-[8px] py-[3px] text-[12px] text-[#f05b5b] bg-[#fff0f0] rounded-[2px]">
        {t('outofstock_status_1')}
      </div>
    );
  }
  if (status === 'OutOfStock') {
    return (
      <div className="inline-block leading-[18px] px-[8px] py-[3px] text-[12px] text-[#00bf69] bg-[#ebfaf3] rounded-[2px]">
        {t('ViewDashboard.LAZADA.Out of stock')}
      </div>
    );
  }
  if (status === 'PartialOutOfStock') {
    return (
      <div className="inline-block leading-[18px] px-[8px] py-[3px] text-[12px] text-[#00bf69] bg-[#ebfaf3] rounded-[2px]">
        {t('outofstock_partial_sku_out')}
      </div>
    );
  }
  if (status === 'ErpInStock') {
    return (
      <div className="inline-block leading-[18px] px-[8px] py-[3px] text-[12px] text-[#096dd9] bg-[#e6f7ff] rounded-[2px]">
        {t('ERP有货')}
      </div>
    );
  }
  if (status === 'ErpOutOfStock') {
    return (
      <div className="inline-block leading-[18px] px-[8px] py-[3px] text-[12px] text-[#cf1322] bg-[#fff1f0] rounded-[2px]">
        {t('ERP缺货')}
      </div>
    );
  }
  return null;
});

export default StatusTag;
